import { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Menu, X } from "lucide-react";

const NAV_LINKS = [
  { label: "Sobre", href: "#institucional" },
  { label: "Serviços", href: "#servicos" },
  { label: "Diferenciais", href: "#diferenciais" },
  { label: "Proprietários", href: "#proprietarios" },
  { label: "Empresas", href: "#empresas" },
];

export const Navbar = ({ onOpenAnunciar }) => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <>
      <motion.header
        initial={{ y: -40, opacity: 0 }}
        animate={{ y: 0, opacity: 1 }}
        transition={{ duration: 0.7, ease: [0.2, 0.8, 0.2, 1] }}
        className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
          scrolled
            ? "bg-[#0B1A3A]/85 backdrop-blur-xl border-b border-[#D4B366]/15 py-3"
            : "bg-transparent py-5"
        }`}
        data-testid="main-navbar"
      >
        <div className="container mx-auto px-6 md:px-12 lg:px-16 flex items-center justify-between">
          <nav className="hidden lg:flex items-center gap-10">
            {NAV_LINKS.map((l) => (
              <a key={l.href} href={l.href} className="nav-link" data-testid={`nav-${l.label.toLowerCase()}`}>
                {l.label}
              </a>
            ))}
          </nav>

          <div className="hidden lg:block">
            <button
              onClick={onOpenAnunciar}
              className="btn-outline-gold"
              data-testid="nav-anunciar-btn"
            >
              Anunciar Imóvel
            </button>
          </div>

          <button
            className="lg:hidden text-[#E8C97A] p-2"
            onClick={() => setOpen(!open)}
            data-testid="mobile-menu-toggle"
            aria-label="Menu"
          >
            {open ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>
      </motion.header>

      <AnimatePresence>
        {open && (
          <motion.div
            initial={{ opacity: 0, y: -20 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -20 }}
            transition={{ duration: 0.3 }}
            className="fixed top-[72px] left-0 right-0 z-40 bg-[#0B1A3A]/98 backdrop-blur-xl border-b border-[#D4B366]/15 lg:hidden"
            data-testid="mobile-menu"
          >
            <div className="container mx-auto px-6 py-6 flex flex-col gap-4">
              {NAV_LINKS.map((l) => (
                <a
                  key={l.href}
                  href={l.href}
                  onClick={() => setOpen(false)}
                  className="nav-link"
                  data-testid={`mobile-nav-${l.label.toLowerCase()}`}
                >
                  {l.label}
                </a>
              ))}
              <button
                onClick={() => {
                  setOpen(false);
                  onOpenAnunciar();
                }}
                className="btn-outline-gold mt-2 w-full"
                data-testid="mobile-nav-anunciar-btn"
              >
                Anunciar Imóvel
              </button>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </>
  );
};
